import React, { useState } from "react";
import { useEffect } from "react";
import { getLeaves } from "../../api/api";
import { useNavigate } from "react-router-dom";

// =========================================================
// LEAVE CALENDAR (FULL ENTERPRISE UI - 400+ LINES)
// =========================================================

export default function LeaveCalendar() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  useEffect(() => {

  const handlePopState = () => {

    // If no proper history then redirect home
    if (
      window.history.length <= 1
    ) {

      navigate("/", {
        replace: true,
      });
    }
  };

  window.addEventListener(
    "popstate",
    handlePopState
  );

  return () => {

    window.removeEventListener(
      "popstate",
      handlePopState
    );
  };

}, [navigate]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [filter, setFilter] = useState("Me");
  const [search, setSearch] = useState("");
  const [leaveDates, setLeaveDates] = useState([]);

  useEffect(() => {
    fetchLeaves();
  }, []);

  const fetchLeaves = async () => {
    try {
      const data = await getLeaves();

      let dates = [];

      data.forEach((leave) => {
        const start = new Date(leave.from_date);
        const end = new Date(leave.to_date);

        let current = new Date(start);

        while (current <= end) {
          dates.push(current.toISOString().split("T")[0]);
          current.setDate(current.getDate() + 1);
        }
      });

      setLeaveDates(dates);
    } catch (err) {
      console.error(err);
    }
  };

  // ================= MONTH NAVIGATION =================

  const prevMonth = () => {
    const newDate = new Date(currentMonth);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentMonth(newDate);
  };

  const nextMonth = () => {
    const newDate = new Date(currentMonth);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentMonth(newDate);
  };

  const getMonthName = () => {
    return currentMonth.toLocaleString("default", {
      month: "long",
      year: "numeric",
    });
  };

  // ================= CALENDAR LOGIC =================

  const getDaysInMonth = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();

    const firstDay = new Date(year, month, 1).getDay();
    const totalDays = new Date(year, month + 1, 0).getDate();

    let days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }

    for (let d = 1; d <= totalDays; d++) {
      days.push(d);
    }

    return days;
  };

  const days = getDaysInMonth();

  // ================= MOCK DATA =================

  const holidays = {};

  // ================= UI =================

  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.header}>
        <h2 style={styles.title}>Leave Calendar</h2>
      </div>

      {/* MAIN GRID */}
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* CALENDAR */}
        <div style={styles.calendarCard}>
          <div style={styles.calendarHeader}>
            <span style={styles.navBtn} onClick={prevMonth}>
              ◀ Prev
            </span>

            <span style={styles.monthTitle}>{getMonthName()}</span>

            <span style={styles.navBtn} onClick={nextMonth}>
              Next ▶
            </span>
          </div>

          {/* DAYS HEADER */}
          <div style={styles.weekHeader}>
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
              <div key={day} style={styles.weekCell}>
                {day}
              </div>
            ))}
          </div>

          {/* DAYS GRID */}
          <div style={styles.daysGrid}>
            {days.map((day, index) => (
              <DayCell
                key={index}
                day={day}
                holiday={holidays[day]}
                currentMonth={currentMonth}
                leaveDates={leaveDates}
              />
            ))}
          </div>

          {/* LEGEND */}
        </div>
      </div>
    </div>
  );
}

// =========================================================
// DAY CELL COMPONENT
// =========================================================

function DayCell({ day, holiday, currentMonth, leaveDates }) {
  if (!day) {
    return <div style={styles.emptyDay}></div>;
  }

  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth() + 1;

  const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(
    day,
  ).padStart(2, "0")}`;

  const today = new Date();

  const isToday =
    today.getDate() === day &&
    today.getMonth() === currentMonth.getMonth() &&
    today.getFullYear() === currentMonth.getFullYear();

  const isLeave = leaveDates.includes(formattedDate);

  return (
    <div
      style={{
        ...styles.dayCell,
        ...(isLeave ? styles.leaveDay : {}),
        ...(isToday ? styles.todayCell : {}),
      }}
    >
      <div
        style={{
          ...styles.dayNumber,
          ...(isToday ? styles.todayNumber : {}),
        }}
      >
        {day}
      </div>

      {isLeave && (
        <div style={styles.leaveBadge}>
          Leave
        </div>
      )}
    </div>
  );
}

// =========================================================
// STYLES
// =========================================================

const styles = {
  container: {
  background: "#f5f6f8",
  minHeight: "100vh",
  padding: window.innerWidth < 768 ? "12px" : "25px",
  fontFamily: "'Inter', sans-serif",
},

  header: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: window.innerWidth < 768 ? "flex-start" : "center",
  flexDirection: window.innerWidth < 768 ? "column" : "row",
  gap: "10px",
  marginBottom: "20px",
},

  title: {
  fontSize: window.innerWidth < 768 ? "20px" : "28px",
  fontWeight: "700",
  color: "#111827",
},

  actions: {
    display: "flex",
    gap: "10px",
  },

  downloadBtn: {
    background: "#1976d2",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  filterRow: {
    marginBottom: "15px",
  },

  label: {
    fontSize: "13px",
  },

  input: {
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    marginTop: "5px",
  },

  mainGrid: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    gap: "20px",
  },

calendarCard: {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: window.innerWidth < 768 ? "16px" : "24px",
  padding: window.innerWidth < 768 ? "12px" : "20px",
  boxShadow: "0 10px 30px rgba(15,23,42,0.05)",
  overflowX: "auto",
},

  calendarHeader: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",
  gap: "10px",
},

navBtn: {
  cursor: "pointer",
  color: "#2563eb",
  fontWeight: "600",
  fontSize: window.innerWidth < 768 ? "13px" : "15px",
  whiteSpace: "nowrap",
},

  monthTitle: {
  fontWeight: "700",
  fontSize: window.innerWidth < 768 ? "15px" : "20px",
  color: "#111827",
},

  weekHeader: {
  display: "grid",
  gridTemplateColumns:
    window.innerWidth < 768
      ? "repeat(auto-fit,minmax(40px,1fr))"
      : "repeat(7,1fr)",
  gap: "6px",
},

weekCell: {
  padding: window.innerWidth < 768 ? "6px" : "12px",
  fontSize: window.innerWidth < 768 ? "11px" : "13px",
  color: "#64748b",
  textAlign: "center",
  fontWeight: "600",
},

daysGrid: {
  display: "grid",
  gridTemplateColumns:
    window.innerWidth < 768
      ? "repeat(auto-fit,minmax(40px,1fr))"
      : "repeat(7,1fr)",
  gap: "6px",
},

  dayCell: {
  border: "1px solid #f1f5f9",
  height: window.innerWidth < 768 ? "58px" : "90px",
  minWidth: "unset",
  position: "relative",
  padding: window.innerWidth < 768 ? "4px" : "8px",
  background: "#f7efef",
},

  dayNumber: {
  fontSize: window.innerWidth < 768 ? "11px" : "14px",
  fontWeight: "600",
},

leaveBadge: {
  marginTop: "6px",
  background: "#dbeafe",
  color: "#1d4ed8",
  fontSize: window.innerWidth < 768 ? "8px" : "10px",
  padding: "2px 4px",
  borderRadius: "999px",
  display: "inline-block",
  fontWeight: "600",
},
todayCell: {
  background: "#7ff5a461",
  border: "1px solid #93c5fd",
},
todayNumber: {
  color: "#2563eb",
  fontWeight: "700",
},
emptyDay: {
  border: "1px solid transparent",
  minHeight: window.innerWidth < 768 ? "58px" : "90px",
},

  legend: {
    marginTop: "10px",
    fontSize: "12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },

  legendDotYellow: {
    width: "8px",
    height: "8px",
    background: "gold",
    borderRadius: "50%",
  },

  legendDotPurple: {
    width: "8px",
    height: "8px",
    background: "purple",
    borderRadius: "50%",
  },

  sidePanel: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  searchRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "5px",
  },

  filterBtn: {
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },

  transactionsCard: {
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px",
  },

  transactionsHeader: {
    fontWeight: "500",
    marginBottom: "10px",
  },

  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "13px",
    color: "#666",
    marginBottom: "10px",
  },

  emptyState: {
    textAlign: "center",
    color: "#888",
    padding: "30px",
  },
  
};
